import { defineComponent as _defineComponent } from 'vue'
import { saveCustomTranslation } from '@/apis/translateApis'
import { translate } from '@/util/commonFun'
import { computed, nextTick, onMounted, ref } from 'vue'

import {
  CustomLangType,
  LangType,
  LangTypeList,
  dealLangJSONToTableData,
} from './utils/dealData'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const langArr: LangTypeList = [
  { name: '英文', value: 'en' },
  { name: '哈萨克语', value: 'kz' },
  { name: '越南语', value: 'vi' },
  { name: '泰语', value: 'th' },
  { name: '印尼语', value: 'id' },
  { name: '维语', value: 'ug' },
  { name: '中文繁体', value: 'zh_hant' },
]

const columns = computed(() => {
  return [
    {
      dataIndex: 'text',
      key: 'text',
      title: translate('translate.text'),
      ellipsis: true,
    },
    {
      title: translate('translate.targetLang'),
      dataIndex: 'targetLang',
      key: 'targetLang',
      ellipsis: true,
    },
    {
      title: translate('translate.customText'),
      dataIndex: 'customText',
      key: 'customText',
      ellipsis: true,
      scopedSlots: { customRender: 'customText' },
    },
  ]
})

/** 节流 */
const isCanSave = ref(true)
/** 当前编辑的行数据key */
const currentEditKey = ref('')
/** 自定义输入框内容 */
const currentCustomText = ref('')
/** 记录原始自定义翻译 */
const currentOriCustomText = ref('')
/** 当前选择的语言 */
const currentLang = ref<LangType[]>(['en'])
/** 列表是否在加载 */
const isLoading = ref<boolean>(false)
/** 表格数据 */
const tableData = ref<Array<CustomLangType>>([])
/** 输入框ref */
const inputRef = ref()
/** 搜索值 */
const searchValue = ref('')

/**
 * @description 选择语言
 * @param lang 选择的语言
 */
const handleChangeLang = async (lang: LangType) => {
  isLoading.value = true
  currentLang.value = [lang]
  tableData.value = await dealLangJSONToTableData(lang)
  isLoading.value = false
}

/**
 * @description 点击自定内容编辑
 * @param cell 当前选中的表格单元格数据
 */
const handleEditCustome = (cell: CustomLangType) => {
  currentEditKey.value = cell.key
  currentCustomText.value = cell.customText
  currentOriCustomText.value = cell.customText
  nextTick(() => {
    inputRef.value?.focus()
  })
}

/**
 * @description 保存自定内容
 * @param cell 当前的单元格编辑内容
 */
const handleSaveCustome = async (cell: CustomLangType) => {
  if (isCanSave.value) {
    if (currentCustomText.value !== currentOriCustomText.value) {
      isLoading.value = true
      isCanSave.value = false
      await saveCustomTranslation({
        mapping_language: currentLang.value[0],
        language_data: [
          {
            zh: cell.text,
            lang_key: cell.key,
            mapping: currentCustomText.value,
          },
        ],
      })
      await handleChangeLang(currentLang.value[0])
      // 节流
      setTimeout(() => {
        isCanSave.value = true
      }, 500)
      isLoading.value = false
    }
    currentEditKey.value = ''
  }
}

const handleSerchTranslate = async () => {
  if (searchValue.value) {
    tableData.value = tableData.value.filter(
      (item) =>
        item.text.includes(searchValue.value) ||
        item.targetLang.includes(searchValue.value)
    )
  } else {
    tableData.value = await dealLangJSONToTableData(currentLang.value[0])
  }
}
const translateLang = (key: string) => {
  return translate(key)
}

onMounted(() => {
  handleChangeLang(currentLang.value[0])
})

return { __sfc: true,langArr, columns, isCanSave, currentEditKey, currentCustomText, currentOriCustomText, currentLang, isLoading, tableData, inputRef, searchValue, handleChangeLang, handleEditCustome, handleSaveCustome, handleSerchTranslate, translateLang }
}

})